import React, { useState } from "react"
import tw, { styled } from "twin.macro"
import { Container } from "../page/gridContainer"
import Link from "next/link"
import { Button } from "../formElements/button"
import { Routes } from "../../routes"
import cookies from "js-cookie"
import { useTranslation } from "next-i18next"
import { DomainPath } from "../../utils/context"

const StyledBanner = styled.div(({ showBanner }: GDPRBannerProps) => [
  tw`py-3 tablet:py-5 fixed bottom-0 text-body-color bg-background w-full z-40`,
  !showBanner && [tw`hidden`],
])

export interface GDPRBannerProps {
  showBanner: boolean
}

export default function GDPRBanner() {
  const { t } = useTranslation("common")
  const cookieConsent = cookies.get("CookieConsent")
  const [showBanner, setShowBanner] = useState(!cookieConsent)

  return (
    <StyledBanner data-theme="dark" showBanner={showBanner}>
      <Container tw="flex items-center justify-between tablet-lg:(justify-center space-x-3)">
        <p tw="text-[10px] font-bold tablet:text-md" css="flex-basis: 70%">
          {t("gdpr.policy")}
          <Link href={{ pathname: Routes.PrivacyPolicy }} passHref>
            <a title="view our Privacy Policy">{t("gdpr.link")}</a>
          </Link>
        </p>
        <Button
          onClick={() => {
            cookies.set("CookieConsent", "true", { domain: `${DomainPath()}`, expires: 365 })
            setShowBanner(false)
          }}
          action={t("gdpr.button")}
        />
      </Container>
    </StyledBanner>
  )
}
